;(function($, g_analytics){

    'use strict';

    var rnn = window.rnn;

    function send_to_ga(category, action, label, value){
        var trackData = {
            tracker: 'send',
            hitType: 'event',
            category: category,
            action: action,
            label: label,
            value: value,
            token: 'trackEvent'
        };

        g_analytics.create_ga_event(trackData);
    }

    function integer(value) {
        return parseInt(value, 10);
    }

    function trackClick(el) {
        var $trackData,
            $container,
            $item,
            action,
            category,
            data,
            label,
            value;

        data = $(el).data();
        $trackData = $(el).data('track');

        $(el).parents('*[data-overlay-marker]')
             .each(function () {
                var data = $(this).data('overlay-marker');
                // faster than an ugly if statement
                switch (data.content_type) {
                    case 'container':
                    case 'pane':
                    case 'fragment':
                        $container = $(this);
                        return false;
                    default:
                        // select only the first parent that isnt a container, pane, fragment
                        if (!$item) {
                            $item = $(this);
                        }
                        break;
                    }
        });

        if($trackData === undefined){
            // just incase the link doesn't have a parent container / pane / fragment
            if (!$container.length) {
                $container =  $item;
            }

            if ($container.data('overlayMarker')) {
                category = $container.data('overlayMarker').label;
            }else{
                category = location.href;
            }

            if ($item && $item.data('overlayMarker')) {
                label = $item.data('overlayMarker').content_type;
            }else{
                label = '';
            }

            action = 'click';
        }else{
            if($trackData.action === undefined){
                action = 'click';
            }else{
                action = $trackData.action;
            }

            if ($trackData.category === undefined) {
                if ($container && $container.data('overlayMarker')) {
                    category = $container.data('overlayMarker').label;
                }else{
                    category = location.href;
                }
            }else{
                category = $trackData.category;
            }

            if ($trackData.label === undefined) {
                if($item && $item.data('overlayMarker')){
                    label = $item.data('overlayMarker').content_type;
                }else{
                    if ($container && $container.data('overlayMarker')) {
                        label = $container.data('overlayMarker').content_type;
                    } else {
                        label = '';
                    }
                }
            } else {
                label = $trackData.label;
            }

        }
        if (!label) {
            label = data.label;
        }
        value = data.value ? integer(data.value) : undefined;

        send_to_ga(category, action, label, value);
    }

    function clickHandler(event) {
        trackClick(this);
    }

    function initLinkTracking() {
        $('.track').on('mousedown', clickHandler);
    }

    function initRecordHits() {
        $('[data-record-hit]').each(function(){
            $.get($(this).data().recordHit);
        });
    }

    function initTrackEvents() {
        // init
        initLinkTracking();
        initRecordHits();
    }

    rnn.modules.register('trackEvents', {
        init: initTrackEvents,
        track_event: send_to_ga,
        trackClick: trackClick
    });

})(jQuery, window.rnn.modules.g_analytics);


